module.exports = __webpack_public_path__ + "public/SiteImages/signupBackArrow.png?1b551172";